export const SET_COUPONCODELIST = "SET_COUPONCODELIST";
export const SET_COUPONOBJECT = "SET_COUPONOBJECT";

